import type { CellContext } from '@tanstack/react-table';
import * as React from 'react';

import type { W_Employee_FindById_VM_Credential } from 'ab-api/web/employee/findById';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import SimpleTable from 'af-components/Controls/SimpleTable/index';
import type { SimpleTableProps } from 'af-components/Controls/SimpleTable/types';
import DateCell from 'af-components/Table6/Cells/DateCell';

import styles from './styles.module.scss';

interface OwnProps {
	credentials: W_Employee_FindById_VM_Credential[];
}

type Props = OwnProps;

const renderDate = (cell: CellContext<W_Employee_FindById_VM_Credential, string>) =>
	<DateCell date={cell.getValue()} dateSourceFormat={TimeFormat.DB_DATE_ONLY} format={TimeFormat.DATE_ONLY} isLeftAligned={true} />;

const renderDaysLeft = (cell: CellContext<W_Employee_FindById_VM_Credential, number>) => {
	if (cell.getValue() >= 0) {
		return cell.getValue();
	}

	const value = -cell.getValue();
	return (
		<div className={styles['expired-msg']}>
			Expired {value} {value === 1 ? 'day' : 'days'} ago
		</div>
	);
};

const EmployeeCredentials: React.FC<Props> = (props) => {
	const { credentials } = props;

	const employeeCredentialColumns: SimpleTableProps<W_Employee_FindById_VM_Credential>['columns'] = React.useMemo(() => [
		{
			id: 'name',
			accessor: 'name',
			header: 'Credential Name',
			cell: (_cell: CellContext<W_Employee_FindById_VM_Credential, number>) => _cell.getValue(),
			enableSorting: true,
		},
		{
			id: 'startDate',
			accessor: 'issuedDate',
			header: 'Issued Date',
			cell: renderDate,
			enableSorting: true,
		},
		{
			id: 'expirationDate',
			accessor: 'expirationDate',
			header: 'Expiration Date',
			cell: renderDate,
			enableSorting: true,
		},
		{
			id: 'daysLeft',
			accessor: 'daysLeft',
			header: 'Days Left',
			cell: renderDaysLeft,
			enableSorting: true,
		},
		{
			id: 'nextReminderDate',
			accessor: 'nextReminderDate',
			header: 'Next Reminder',
			cell: renderDate,
			enableSorting: true,
		},
	], []);

	return (
		<SimpleTable
			columns={employeeCredentialColumns}
			label="Credentials"
			rows={credentials}
		/>
	);
};

export default React.memo(EmployeeCredentials);
